<template>
   <NuxtLink
      class="__clickable p-l rounded-small border-light-grey hover:bg-light-grey group flex justify-between border px-4 py-2"
      :to="to"
   >
      <div class="flex items-center gap-3">
         <div class="rounded-small size-5 overflow-hidden">
            <Image class="size-full object-cover" :src="image" />
         </div>
         <span class="transition-[padding]">
            {{ name }}
         </span>
      </div>
      <div class="opacity-0 transition-[opacity,padding] group-hover:pr-2 group-hover:opacity-100">
         <Icon name="chevron-down-mini" class="size-6 -rotate-90" />
      </div>
   </NuxtLink>
</template>

<script lang="ts" setup>
type Props = {
   name?: string | null
   to: string
   image?: string
}

const props = withDefaults(defineProps<Props>(), {})
</script>
